import {
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  Input,
  NgZone
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, fromEvent } from 'rxjs';

@Directive({
  selector: '[scroll]'
})
export class ScrollDirective {
  @Input()
  set scroll(type: 'vertical'|'horizontal'|'vertical-light') {
    this.elementRef.nativeElement
      .classList
      .add('scroll', `scroll_${ type }`);
  }

  @Input()
  set hasMask(hasMask: true) {
    this.setupScrollListener();
  }

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly ngZone = inject(NgZone);
  private readonly destroyRef = inject(DestroyRef);

  scrollDown(): void {
    const { nativeElement } = this.elementRef;

    nativeElement.scrollTop = nativeElement.scrollHeight;
  }

  private setupScrollListener(): void {
    this.ngZone.runOutsideAngular(() => {
      const { nativeElement } = this.elementRef;

      fromEvent(nativeElement, 'scroll', { passive: true })
        .pipe(
          debounceTime(150),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(() => {
          const isAtBottom = nativeElement.scrollHeight - nativeElement.scrollTop === nativeElement.clientHeight;

          if(isAtBottom) {
            nativeElement.classList.add('no-mask');
          } else {
            nativeElement.classList.remove('no-mask');
          }
        });
    });
  }
}